import { render, staticRenderFns } from "./ChangeFishery.vue?vue&type=template&id=78a0a673&scoped=true&"
import script from "./ChangeFishery.vue?vue&type=script&lang=js&"
export * from "./ChangeFishery.vue?vue&type=script&lang=js&"
import style0 from "./ChangeFishery.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a0a673",
  null
  
)

export default component.exports